import React from "react"
import SearchForBlogSections from "@utils/searchForBlogSections"
import { useArticlePage } from "../../hooks"
import {
    BackToBlogButton,
    SidebarNavigation,
    ArticleInformation,
    TabletArticleNavigation,
    AuthorInformation,
    OtherArticles,
} from "./components"
import {
  StyledArticleWrapper,
  StyledArticleSidebarWrapper,
  StyledMainContentWrapper,
  StyledMainArticleContent,
} from "./styled"

const ArticlePage = ({ postsList, post }) => {
  const {
    isMounted,
    isDesktop,
    isTablet,
    isMobile,
    otherArticles,
    articleTopics,
    content,
    setSelectedItem,
  } = useArticlePage({ postsList, post })

  return isMounted && (
    <StyledArticleWrapper>
      {isDesktop && (
        <StyledArticleSidebarWrapper>
          <BackToBlogButton />
          <SidebarNavigation
            articleTopics={articleTopics}
            setSelectedItem={setSelectedItem}
          />
        </StyledArticleSidebarWrapper>
      )}
      <StyledMainContentWrapper>
        <ArticleInformation
          title={post.title}
          category={post.category}
          date={post.date}
          read_time={post.read_time}
          author={post.author}
        />
        {(isTablet || isMobile) && (
          <TabletArticleNavigation
            articleTopics={articleTopics}
            setSelectedItem={setSelectedItem}
          />
        )}
        <StyledMainArticleContent
          dangerouslySetInnerHTML={{
            __html: SearchForBlogSections.replaceContentToMarkup(content),
          }}
        />
        <AuthorInformation
          author={post.author}
          meta_url={post.meta_url}
        />
        <OtherArticles otherArticles={otherArticles} />
      </StyledMainContentWrapper>
    </StyledArticleWrapper>
  )
}

export default ArticlePage
